export default __webpack_public_path__ + "static/media/locked.fbedfbda.svg";